





































































































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import {
  CREATE_PROFILE_LIST,
  GET_REGISTER_PROFILE_FORM_VISIBILITY,
  UPDATE_REGISTER_PROFILE_FORM_VISIBILITY,
  GET_SELECTED_PROFILE,
  UPDATE_SELECTED_PROFILE,
  FETCH_PROFILE_LIST,
  CREATE_NEW_PROFILE,
  UPDATE_PROFILE_LIST,
  UPDATE_PROFILE,
  GET_FLAG_LIST,
  GET_COUNTRY_LIST,
  GET_VEHICLE_TYPE_LIST,
  UPDATE_CURRENT_PROFILE_TAB,
} from '@/modules/profile/store';

import {
  FETCH_FUNCTIONALITY_LIST,
  FETCH_GROUPED_FUNCTIONALITY_LIST,
  GET_FUNCTIONALITY_LIST,
  GET_GROUPED_FUNCTIONALITY_LIST,
} from '@/modules/functionality/store';

import { MessageService } from '@/services/messageService';
import { IProfile, profileTabs } from '@/modules/profile/models';
import { IFlag, ICountry, IVehicleType } from '@/models';
import { IFunctionality } from '@/modules/functionality/models';

@Component
export default class extends Vue {
  public valid: boolean = false;
  public saving: boolean = false;
  public state: any = {};
  public search: string = '';
  public selectionType: string = 'leaft';
  public newProfile: IProfile = {
    id: 0,
    idvehicle: 0,
    idcountry: 0,
    idflag: 0,
    name: '',
    isactive: true,
    needacceptancetermsofuse: false,
    vehicletype: { id: 0, vehicletypename: '' },
    flag: { id: 0, flagname: '' },
    country: { id: 0, countryname: '' },
    functionalities: [],
  };

  public nameRules: any[] = [
    (v: any) => !!v || 'Nome é obrigatório',
    (v: any) =>
      (v && v.length <= 256) || 'Nome precisa ter menos que 256 caracteres',
  ];

  @Getter(GET_SELECTED_PROFILE)
  public profileSelected: IProfile;

  @Getter(GET_FLAG_LIST)
  public flags: IFlag[];

  @Getter(GET_COUNTRY_LIST)
  public countries: ICountry[];

  @Getter(GET_VEHICLE_TYPE_LIST)
  public vehicleTypes: IVehicleType[];

  @Getter(GET_FUNCTIONALITY_LIST)
  public functionalities: IFunctionality[];

  @Getter(GET_GROUPED_FUNCTIONALITY_LIST)
  public groupedFunctionalities: any[];

  @Action(CREATE_NEW_PROFILE) // Cria o perfil no banco.
  public createProfile: any;

  @Action(UPDATE_PROFILE_LIST) // Atualiza a lista de perfis.
  public updateProfiles: any;

  @Action(UPDATE_SELECTED_PROFILE) // Seta o perfil atual selecionado.
  private setSelectedProfile: any;

  @Action(UPDATE_PROFILE) // Atualiza o perfil no banco.
  private updateProfile: any;

  @Action(FETCH_PROFILE_LIST) // Recupera a lista de perfis do banco.
  private getAllFProfiles: any;

  @Action(CREATE_PROFILE_LIST)
  private setAllProfiles: any;

  @Action(UPDATE_CURRENT_PROFILE_TAB)
  private setCurrentTab: any;

  @Action(FETCH_GROUPED_FUNCTIONALITY_LIST)
  private getAllGroupedFunctionalities: any;

  public cancelEdit() {
    this.setSelectedProfile(this.newProfile);
    this.getAllFProfiles(true).then((ret: any) => {
      this.setAllProfiles(ret.data);
      this.setCurrentTab(profileTabs.tabs.listtab);
    });
  }

  public saveProfile() {
    if (this.profileSelected.id === 0) {
      this.addProfile();
    } else {
      this.update();
    }
  }

  public created() {
    this.getAllGroupedFunctionalities();
  }

  private addProfile() {
     this.saving = true;
     this.createProfile(this.profileSelected).then((ret: any) => {
      MessageService.Success('Sucesso', 'Operação realizada com sucesso.');
      this.cancelEdit();
    })
    .finally(() => (this.saving = false));
  }

  private update() {
     this.saving = true;
     this.updateProfile(this.profileSelected).then(() => {
    this.getAllFProfiles(true).then((ret: any) => {
      this.setAllProfiles(ret.data);
      this.resetParameters();
    });
    }).finally(() => (this.saving = false));
  }

  private resetParameters() {
    MessageService.Success('Sucesso', 'Operação realizada com sucesso.');

    this.setSelectedProfile(this.newProfile);
    this.setCurrentTab(profileTabs.tabs.listtab);
  }
}
